import styled from 'styled-components';

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  height: 32px;
  width: 32px;

  & > svg {
    object-fit: contain;
  }
`;

export const Description = styled.p`
  all: unset;
  color: ${({ theme }) => theme.colors.gray};
  margin: 1px 0;
`;
